import { styled, theme } from "@theme/stitches.config"
import { HeroWrapper } from "@components/Hero/styles"

export const ContentHeroWrapper = styled(HeroWrapper, {
    backgroundColor: theme.colors.N900,
    justifyContent: "unset",
    padding: "0 100px",
    "@mdDown": {
        padding: "0 20px"
    }
})

export const Overlay = styled("div", {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%)",
    zIndex: 1
})

export const BackgroundImageWrapper = styled("div", {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    "& img, & .gatsby-image-wrapper, * .gatsby-image-wrapper img": {
        width: "100%",
        height: "100%",
        objectFit: "cover"
    }
})

export const InnerContentWrapper = styled("div", {
    maxWidth: 920,
    padding: "100px 0"
})

export const StyledSpan = styled("div", {
    position: "absolute",
    left: "50%",
    bottom: 90,
    zIndex: 10,
    transform: "translate(-50%, 50%)",
    color: theme.colors.white,
    appearance: "none",
    cursor: "pointer",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    border: "3px solid transparent",
    borderRadius: 4,
    p: "10px 41px",
    fontSize: theme.fontSizes.desktopH6,
    textDecoration: "none",
    fontFamily: theme.fonts.heading,
    lineHeight: 1.2,
    transition: "all 200ms ease",
    outline: "none",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    "@mdDown": {
        display: "none"
    }
})
